import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import styled from 'styled-components';
import { CardContext } from '../Card';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledMetadata = styled.div.withConfig({
  displayName: "Metadata__StyledMetadata",
  componentId: "sc-1rkffcx-0"
})(["color:var(--dentsu-color-n700);font-size:var(--dentsu-spacing-12);font-weight:var(--dentsu-font-weight-regular);line-height:var(--dentsu-leading-tight);margin:", ";.", "-link{font-size:var(--dentsu-spacing-12);}"], function (props) {
  return props.variant === 'list' ? 'var(--dentsu-spacing-4) 0' : 'var(--dentsu-spacing-8) 0';
}, prefix);
var Metadata = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      dataFromProps = _ref.data,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx(_defineProperty({}, "".concat(prefix, "-card__metadata"), true));

  var _useContext = useContext(CardContext),
      variant = _useContext.variant;

  return _jsx(StyledMetadata, _objectSpread(_objectSpread({
    ref: ref,
    className: className,
    variant: variant
  }, rest), {}, {
    children: dataFromProps || children
  }));
});
export default Metadata;